import React from 'react';
import { Row, Col, Button, Form, FormGroup, ListGroup, ListGroupItem } from 'reactstrap';

import Body from '../Components/layout/Body';
import LoginNotice from './LoginNotice';

const PVIEW_HELP = `
<div>
  <p>The practitioner page has two main purposes:</p>
  <p>First, it lets you <strong>select the client you'll be working with for this evaluation.</strong>  To store the data for a client evaluation, you first need to select the client - that's how Access Nav will know whose data it is and how to store it.</p>
  <p>If you've got some clients stored already, you'll see a list of those here to choose from. Or if it's your first time using Access Nav with a client / student, you can create a new client.</p>
  <p><strong>Note: </strong>If you just want to use the app without saving any data, you can just Continue from here without selecting a client.</p>
  <p>The second main purpose is to let you <strong>change your account info</strong> (the Email and Preferred Name for your account).</p>
  <p><strong>Another Note:</strong> All of the above assumes that you are logged into your practitioner account.  If you aren't logged in, you'll see a message on this page to that effect, with suggestions on what to do next.</p>
</div>
`;

//content sub-component with unique content for this page
function UsersProviderViewContent(props) {
  const {
    provider,
    clients,
    selectedClient,
    onClientClicked,
    goToCreateClient,
    goToRequestAccess,
    goToUpdateUser,
  } = props;
  console.log("rendering UsersProviderViewContent", clients);

  return(
    <>
    {!provider && <LoginNotice message="To select and create clients, "/>}
    <Form>
      <FormGroup>
        <ListGroup className="aa-client-list">
          {clients && clients.length > 0 ? (
            clients.map((client, index) => {
            return (
              <ListGroupItem key={index} header={client.id} active={client.id === selectedClient} onClick={onClientClicked}>
                { client.alias
                  ? client.alias + ' (' + client.username + ')'
                  : client.username}
                {' --- '}
                {(new Date(client.updatedAt)).toLocaleString()}
              </ListGroupItem>
            );
          })) : (
            <ListGroupItem key="no-clients" header="No clients" disabled={true}>
              You currently have no clients
            </ListGroupItem>
          )}
        </ListGroup>
      </FormGroup>
    </Form>
    <p><strong>Note: </strong>If you just want to explore, <strong>without saving any of the data,</strong> you can also Continue without selecting a client.</p>
    <Row className="aa-review-row">
      <Col>
        <Button color="secondary" className={(provider) ? "" : "disabled"} onClick={goToCreateClient}>
            Create a new client
          </Button>
      </Col>
      <Col>
        <Button color="secondary" className={(provider) ? "" : "disabled"} onClick={goToRequestAccess}>
          Request access to another client
        </Button>
      </Col>
    </Row>
    <Row>
      <Col>
        <Button color="link" className={(provider) ? "" : "disabled"} onClick={goToUpdateUser}>
          Change your account info
        </Button>
      </Col>
    </Row>
    <br/>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function UsersProviderView(props) {
  const {
    provider,
    clients,
    selectedClient,
    onClientClicked,
    goToCreateClient,
    goToRequestAccess,
    goToUpdateUser,
    goToUpdateCredentials,
    onContinue
  } = props;


  let title = "";
  if (provider && provider.alias){
    title = `Welcome, ${provider.alias}!`;
  }
  else
    title = "Welcome!";

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used, but could supply an image on page
    faIcon: "fa-users aa-fa-3x", //include this font-awesome icon in the image column of the page
    title: title,
    subTitle: "Choose a client you've worked with in the past, or create a new one.",
    learnMore: {linkText: "Learn More about this practitioner admin page",
                title: "Practitioner page",
                content: PVIEW_HELP
                },
    nextRoute: '', 
    sidebar: false
  }

  console.log("rendering UsersProviderView, selectedClient: ", selectedClient);

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <UsersProviderViewContent 
          provider={provider}
          clients={clients}
          selectedClient={selectedClient}
          onClientClicked={onClientClicked}
          goToCreateClient={goToCreateClient}
          goToRequestAccess={goToRequestAccess}
          goToUpdateUser={goToUpdateUser}
          goToUpdateCredentials={goToUpdateCredentials}
        />
      } 
      onContinue={onContinue}
    />
    </>
  );
}

export default UsersProviderView;